import type en from "../en/settings";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  // Shared
  unknownItem: "عنصر غير معروف",
  viewPlans: "عرض الخطط",
  primary: "أساسي",
  makePrimary: "تعيين كأساسي",
  deleteNamed: "حذف «{name}»؟",
  addRate: "إضافة السعر",
  saveRate: "حفظ السعر",
  addRateSummary: "+ إضافة سعر",
  yourRole: "دورك",

  // Shared settings components
  mediaPreviewAlt: "معاينة {label}",
  mediaCurrentImage: "الصورة الحالية",
  mediaReplaceImage: "استبدال الصورة",
  mediaUploadImage: "رفع صورة",
  multiSelectSearch: "بحث…",
  multiSelectNone: "لم يتم اختيار شيء",
  multiSelectRemove: "إزالة {label}",
  multiSelectFilter: "{label}: تصفية الخيارات",
  multiSelectNoMatches: "لا توجد نتائج مطابقة",
  rateType: "نوع السعر",
  rateKindFlat: "سعر ثابت",
  rateKindWeight: "حسب الوزن",
  rateKindPrice: "حسب قيمة الطلب",
  rateKindFree: "شحن مجاني",
  rateKindPickup: "استلام محلي",
  rateHelpFlat: "سعر واحد لكل الطلبات في هذه المنطقة.",
  rateHelpWeight: "يُطبَّق عندما يقع الوزن الإجمالي للطلب ضمن النطاق.",
  rateHelpPrice: "يُطبَّق عندما يقع المجموع الفرعي للطلب ضمن النطاق.",
  rateHelpFree: "بدون رسوم. حدّد حدًا أدنى لقيمة الطلب لتقديم «شحن مجاني للطلبات التي تتجاوز …».",
  rateHelpPickup: "يستلم العميل الطلب بنفسه. يمكنك اختياريًا فرض رسوم تجهيز.",
  rateHandlingFee: "رسوم التجهيز",
  ratePrice: "السعر",
  rateFreeOver: "مجاني للطلبات التي تتجاوز",
  rateMinOrder: "الحد الأدنى لقيمة الطلب",
  rateMaxOrder: "الحد الأقصى لقيمة الطلب",
  rateNoMinimum: "بدون حد أدنى",
  rateNoMaximum: "بدون حد أقصى",
  rateMinWeight: "الحد الأدنى للوزن (غرام)",
  rateMaxWeight: "الحد الأقصى للوزن (غرام)",
  inviteLinkNote: "إرسال البريد الإلكتروني غير مُعدّ على هذه المنصة، لذا شارك هذا الرابط أحادي الاستخدام مع الشخص بنفسك. تنتهي صلاحيته بعد 7 أيام ولا يعمل إلا مع عنوان البريد الإلكتروني المدعو.",
  inviteRole: "الدور",
  inviteSending: "جارٍ الإرسال…",
  inviteSend: "إرسال الدعوة",

  // Store details
  detailsTitle: "بيانات المتجر",
  detailsDescription: "معلومات أساسية عن متجرك، تُستخدم في واجهة المتجر والفواتير ورسائل البريد الإلكتروني.",
  detailsGeneral: "عام",
  detailsStoreName: "اسم المتجر",
  detailsDescriptionHint: "ملخص قصير لما تبيعه (500 حرف كحد أقصى).",
  detailsContactEmail: "البريد الإلكتروني للتواصل",
  detailsContactEmailHint: "يظهر للعملاء ويُستخدم كعنوان للرد على رسائل الطلبات.",
  detailsContactPhone: "هاتف التواصل",
  detailsPlatformAddress: "العنوان على المنصة: {url}",
  detailsBusinessAddress: "عنوان النشاط التجاري",
  detailsBusinessAddressDesc: "يُستخدم في الفواتير ويظهر في معلومات التواصل الخاصة بمتجرك.",
  detailsLine1: "سطر العنوان 1",
  detailsLine2: "سطر العنوان 2",
  detailsCity: "المدينة",
  detailsRegion: "المنطقة / الولاية",
  detailsPostalCode: "الرمز البريدي",
  detailsCountry: "الدولة",
  detailsCountryHint: "البلد الأساسي لمتجرك. يُستخدم أيضًا في الإعداد الافتراضي للشحن والضرائب.",
  detailsRegional: "الإعدادات الإقليمية",
  detailsStorefrontLanguage: "لغة واجهة المتجر",
  detailsTimezone: "المنطقة الزمنية",
  detailsWeightUnit: "وحدة الوزن",
  detailsUnitKg: "كيلوغرام (kg)",
  detailsUnitG: "غرام (g)",
  detailsUnitLb: "رطل (lb)",
  detailsUnitOz: "أونصة (oz)",
  detailsLogoFavicon: "الشعار وأيقونة الموقع",
  detailsLogo: "الشعار",
  detailsFavicon: "أيقونة الموقع",
  detailsFaviconHint: "صورة مربعة بحجم 64×64 بكسل على الأقل.",
  detailsSearchListing: "الظهور في محركات البحث",
  detailsSearchListingDesc: "العنوان والوصف الافتراضيان لصفحتك الرئيسية في نتائج البحث.",
  detailsSeoTitle: "عنوان SEO",
  detailsSeoTitleHint: "حتى 70 حرفًا.",
  detailsMetaDescription: "الوصف التعريفي (Meta)",
  detailsMetaDescriptionHint: "حتى 160 حرفًا.",
  detailsNoindex: "إخفاء متجري عن محركات البحث",
  detailsNoindexHint: "يضيف توجيه noindex. مفيد ما دمت لا تزال تبني متجرك.",
  detailsSave: "حفظ بيانات المتجر",
  detailsSaved: "تم حفظ بيانات المتجر",
  currencyTitle: "العملة",
  currencyUses: "تستخدم الأسعار والتقارير العملة {currency}.",
  currencyChange: "تغيير العملة",
  currencyWarning: "لا يتم تحويل أسعار المنتجات. راجع أسعارك بعد تغيير العملة.",
  currencyNew: "العملة الجديدة",
  currencyLocked: "لا يمكن تغيير العملة بعد تقديم طلبات، حتى يبقى سجل طلباتك متّسقًا.",
  currencyChanged: "تم تغيير عملة المتجر إلى {currency}. راجع أسعار منتجاتك، فلم يتم تحويل المبالغ.",
  planUsage: "استخدام الخطة",
  planUsageOn: "أنت على خطة {plan}.",
  usageProducts: "المنتجات",
  usageStaff: "حسابات الموظفين",
  usageDomains: "النطاقات المخصصة",
  usageStorage: "التخزين (ميغابايت)",
  managePlan: "إدارة الخطة والفوترة ←",
  ownerManagesPlan: "يدير مالك المتجر الخطة.",

  // Taxes
  taxDescription: "معدلات الضريبة المطبقة عند الدفع.",
  taxDisclaimerTitle: "معدلات الضريبة تُدخلها أنت",
  taxDisclaimer: "تطبّق Storelancer المعدلات التي تُعدّها هنا بالضبط. لا تحدد المنصة الضرائب التي تنطبق على نشاطك التجاري، ولا تحسب الضرائب الخاصة بكل ولاية قضائية (مثل ضريبة القيمة المضافة أو GST أو ضريبة المبيعات الأمريكية) تلقائيًا. استشر مستشارًا ضريبيًا بشأن التزاماتك.",
  taxCalculation: "حساب الضريبة",
  taxPricesInclude: "الأسعار شاملة الضريبة",
  taxPricesIncludeHint: "شائع في الاتحاد الأوروبي والمملكة المتحدة وأستراليا. تُحتسب الضريبة كجزء من السعر بدلًا من إضافتها عند الدفع.",
  taxOnShipping: "فرض ضريبة على الشحن",
  taxOnShippingHint: "يخضع الشحن للضريبة باستخدام المعدلات المحددة بـ«تنطبق على الشحن».",
  taxRates: "معدلات الضريبة",
  taxRatesDesc: "تنطبق معدلات بلد العميل على جميع العناوين فيه، وتُضاف معدلات المنطقة فوقها للعناوين الواقعة في تلك المنطقة. تُجمع المعدلات المطابقة معًا.",
  taxNoRates: "لا توجد معدلات ضريبة",
  taxNoRatesDesc: "بدون معدلات ضريبة، لا تُفرض أي ضريبة عند الدفع.",
  taxColLocation: "الموقع",
  taxColRate: "المعدل",
  taxColClass: "الفئة",
  taxColShipping: "الشحن",
  taxAllProducts: "جميع المنتجات",
  taxEditRate: "تعديل {name} ({location})",
  taxAddRate: "+ إضافة معدل ضريبة",
  taxNameHint: "يظهر في الإيصالات، مثل «ضريبة القيمة المضافة».",
  taxRegionCode: "رمز المنطقة",
  taxRegionCodeHint: "مثل CA لولاية كاليفورنيا. فارغ = البلد بأكمله.",
  taxRatePercent: "المعدل (%)",
  taxRatePercentHint: "منزلتان عشريتان كحد أقصى.",
  taxClass: "فئة الضريبة",
  taxClassHint: "ينطبق فقط على المنتجات من فئة الضريبة هذه. فارغ = جميع المنتجات الخاضعة للضريبة (والشحن).",
  taxAppliesToShipping: "تنطبق على الشحن",
  taxAppliesToShippingHint: "يُستخدم فقط عند تفعيل «فرض ضريبة على الشحن».",
  taxSettingsSaved: "تم حفظ إعدادات الضريبة",
  taxUnknownRate: "معدل ضريبة غير معروف",
  taxInvalidPercent: "أدخل نسبة مئوية بمنزلتين عشريتين كحد أقصى، مثل 20 أو 7.25.",
  taxInvalidPercentField: "نسبة مئوية غير صالحة",
  taxRateUpdated: "تم تحديث معدل الضريبة",
  taxRateAdded: "تمت إضافة معدل الضريبة",
  taxRateDeleted: "تم حذف معدل الضريبة",

  // Checkout
  checkoutDescription: "تحكّم في ما يجب على العملاء تقديمه عند إتمام الطلب.",
  checkoutCustomerInfo: "معلومات العميل",
  checkoutGuest: "السماح بالدفع كضيف",
  checkoutGuestHint: "يمكن للعملاء الطلب دون إنشاء حساب. إيقاف هذا الخيار يفرض إنشاء حساب لكل طلب، ما يقلل عادةً من معدل التحويل.",
  checkoutPhone: "طلب رقم الهاتف إلزاميًا",
  checkoutPhoneHint: "مفيد لشركات التوصيل والدفع عند الاستلام.",
  checkoutTerms: "طلب الموافقة على الشروط",
  checkoutTermsHint: "يجب على العملاء تحديد مربع للموافقة على شروطك وسياساتك. عدّلها من {pages}.",
  checkoutNotes: "السماح بملاحظات الطلب",
  checkoutNotesHint: "يمكن للعملاء إضافة ملاحظة لك (مثل تعليمات التوصيل).",
  checkoutReservation: "حجز المخزون للمدفوعات الإلكترونية",
  checkoutReservationText: "عند توجيه العميل إلى صفحة دفع إلكتروني (Stripe أو PayPal)، تُحجز المنتجات له حتى لا تنفد أثناء الدفع. إذا لم يكتمل الدفع خلال هذه المدة، تنتهي صلاحية الطلب ويُحرَّر المخزون. أما طرق الدفع غير الإلكترونية (الدفع عند الاستلام، التحويل البنكي) فتُبقي المخزون محجوزًا حتى تلغي الطلب أو تحدده كمدفوع.",
  checkoutReservationTime: "مدة الحجز (بالدقائق)",
  checkoutReservationHint: "بين 10 و1440 دقيقة (24 ساعة). تناسب 30 دقيقة معظم المتاجر.",
  checkoutSave: "حفظ إعدادات الدفع",
  checkoutSaved: "تم حفظ إعدادات الدفع",

  // SEO
  seoDescription: "ساعد محركات البحث في العثور على متجرك وحافظ على عمل الروابط القديمة.",
  seoSearchEngines: "محركات البحث",
  seoSitemapText: "ينشر متجرك تلقائيًا خريطة موقع وملف robots. أرسل خريطة الموقع عبر Google Search Console أو Bing Webmaster Tools.",
  seoStoreWideText: "تجد العنوان والوصف العامّين للمتجر وخيار «الإخفاء عن محركات البحث» في {link}. للمنتجات والمجموعات والصفحات حقول SEO خاصة بها في محرراتها. لا تتم أرشفة المتاجر غير المنشورة.",
  seoRedirects: "عمليات إعادة توجيه الروابط",
  seoRedirectsDesc: "أعِد توجيه الزوار (ومحركات البحث) من مسار قديم إلى موقع جديد عبر إعادة توجيه دائمة (301). لا تُطبَّق عمليات إعادة التوجيه إلا عندما لا يعود المسار القديم موجودًا في متجرك.",
  seoFromPath: "من المسار",
  seoFromPathHint: "مسار في متجرك، مثل ‎/old-sale",
  seoTo: "إلى",
  seoToHint: "مسار، مثل ‎/products/new-item، أو رابط https://‎",
  seoAddRedirect: "إضافة إعادة توجيه",
  seoNoRedirects: "لا توجد عمليات إعادة توجيه",
  seoNoRedirectsDesc: "أضف واحدة عند إعادة تسمية منتج أو مجموعة أو صفحة حتى تستمر الروابط القديمة في العمل.",
  seoColFrom: "من",
  seoColTo: "إلى",
  seoDeleteRedirect: "حذف إعادة التوجيه؟",
  seoDeleteRedirectBody: "لن تتم إعادة توجيه {path} بعد الآن.",
  seoRedirectSaved: "تم حفظ إعادة التوجيه",
  seoRedirectDeleted: "تم حذف إعادة التوجيه",
  seoUnknownRedirect: "إعادة توجيه غير معروفة",

  // Shipping
  shipDescription: "الأماكن التي تشحن إليها وما يدفعه العملاء مقابل التوصيل.",
  shipHowTitle: "كيف تتم مطابقة الشحن",
  shipHow1: "عند الدفع، يحدد بلد العميل (ورمزه البريدي إذا كانت المنطقة تحدد بادئات) المنطقة. تُفضَّل المنطقة التي تذكر البلد صراحةً على «بقية العالم».",
  shipHow2: "يُعرض كل سعر نشط في تلك المنطقة تتطابق شروطه مع السلة (قيمة الطلب، الوزن)، ويختار العميل واحدًا منها.",
  shipHow3: "إذا لم تتطابق أي منطقة أو سعر، فلن يتمكن العميل من إتمام الطلب للمنتجات التي تحتاج إلى شحن. المنتجات الرقمية والخدمات لا تحتاج إلى شحن أبدًا.",
  shipNoActiveRate: "أنت تبيع منتجات مادية لكن ليس لديك سعر شحن نشط، لذا لا يستطيع العملاء إتمام الدفع.",
  shipNoZones: "لا توجد مناطق شحن بعد",
  shipNoZonesDesc: "أنشئ منطقة لـ{country} (أو لكل الأماكن التي تشحن إليها) وأضف سعرًا واحدًا على الأقل.",
  shipNoZonesAction: "استخدم «إضافة منطقة شحن» أدناه.",
  shipAddZone: "إضافة منطقة شحن",
  shipRestOfWorld: "بقية العالم",
  shipKindFlat: "سعر ثابت",
  shipKindWeight: "حسب الوزن",
  shipKindPrice: "حسب قيمة الطلب",
  shipKindFree: "شحن مجاني",
  shipKindPickup: "استلام محلي",
  shipZoneName: "اسم المنطقة",
  shipZoneNameHint: "يظهر لك فقط، مثل «محلي» أو «أوروبا».",
  shipCountries: "الدول",
  shipCountriesHint: "اختر «بقية العالم» لتغطية كل الدول غير المدرجة في منطقة أخرى.",
  shipPostalPrefixes: "بادئات الرموز البريدية",
  shipPostalPrefixesHint: "اقصر المنطقة على الرموز البريدية التي تبدأ بهذه القيم، مفصولة بفواصل أو أسطر جديدة (مثل 75، 92، 93). اتركه فارغًا ليشمل البلد بأكمله.",
  shipSaveZone: "حفظ المنطقة",
  shipCreateZone: "إنشاء المنطقة",
  shipRateName: "اسم السعر",
  shipRateNameHint: "يظهر للعملاء عند الدفع.",
  shipRateNamePlaceholder: "شحن عادي",
  shipDeliveryEstimate: "مدة التوصيل المتوقعة",
  shipDeliveryEstimatePlaceholder: "من 2 إلى 4 أيام عمل",
  shipActive: "نشط",
  shipActiveHint: "لا تُعرض الأسعار غير النشطة عند الدفع أبدًا.",
  shipOrdersBetween: "الطلبات من {min} إلى {max}",
  shipOrdersOver: "الطلبات التي تتجاوز {min}",
  shipOrdersUpTo: "الطلبات حتى {max}",
  shipWeightRange: "{min} غ – {max}",
  shipWeightGrams: "{value} غ",
  shipWeightAny: "أي وزن",
  shipCountriesMore: "{list} و{count} أخرى",
  shipPostalStarting: "الرموز البريدية التي تبدأ بـ: {prefixes}",
  shipDeleteZone: "حذف المنطقة",
  shipDeleteZoneBody: "سيتم حذف المنطقة وأسعارها (العدد: {count}). لن يتمكن العملاء في هذه الدول من اختيار هذه الأسعار.",
  shipDeleteZoneBody_one: "سيتم حذف المنطقة وسعرها الوحيد. لن يتمكن العملاء في هذه الدول من اختيار هذا السعر.",
  shipNoRates: "لا توجد أسعار بعد، لذا لا يستطيع العملاء في هذه المنطقة إتمام الطلب للمنتجات المادية.",
  shipInactive: "غير نشط",
  shipNoConditions: "بدون شروط",
  shipFree: "مجاني",
  shipDeleteRate: "حذف السعر",
  shipEditRate: "تعديل السعر",
  shipEditZone: "تعديل المنطقة",
  shipZoneUpdated: "تم تحديث المنطقة",
  shipZoneCreated: "تم إنشاء المنطقة، أضف إليها الآن سعرًا.",
  shipZoneDeleted: "تم حذف المنطقة",
  shipRateUpdated: "تم تحديث السعر",
  shipRateAdded: "تمت إضافة السعر",
  shipRateDeleted: "تم حذف السعر",

  // Domains
  domainDescription: "استخدم اسم النطاق الخاص بك لواجهة متجرك.",
  domainStatusPending: "بانتظار التحقق",
  domainStatusVerified: "تم التحقق",
  domainStatusFailed: "فشل التحقق",
  domainSslPending: "SSL قيد الانتظار",
  domainSslActive: "SSL نشط",
  domainSslFailed: "فشل SSL",
  domainSslUnknown: "حالة SSL غير معروفة",
  domainPlatformAddress: "العنوان على المنصة",
  domainPlatformAddressDesc: "متاح دائمًا ومجاني، ويشمل HTTPS.",
  domainConnect: "ربط نطاق",
  domainUsage: "النطاقات المخصصة المستخدمة: {used} من {count} ضمن خطة {plan}.",
  domainUsage_one: "النطاقات المخصصة المستخدمة: {used} من {count} ضمن خطة {plan}.",
  domainNotIncluded: "النطاقات المخصصة غير مشمولة في خطة {plan}",
  domainUpgrade: "قم بترقية خطتك لربط نطاق تملكه.",
  domainAtLimit: "لقد بلغت الحد الأقصى للنطاقات في خطتك. احذف نطاقًا أو قم بالترقية لإضافة نطاق آخر.",
  domainField: "النطاق",
  domainFieldHint: "مثل shop.example.com أو example.com، ويجب أن تكون مالكه.",
  domainAdd: "إضافة النطاق",
  domainNone: "لا توجد نطاقات مخصصة",
  domainNoneDesc: "يمكن الوصول إلى متجرك عبر عنوانه على المنصة.",
  domainLastChecked: "آخر فحص: {date}",
  domainChecking: "جارٍ الفحص…",
  domainCheckNow: "افحص الآن",
  domainRemoveTitle: "إزالة {host}؟",
  domainRemove: "إزالة النطاق",
  domainRemovePrimaryBody: "هذا هو نطاقك الأساسي. سيعود متجرك إلى العنوان على المنصة. تذكّر حذف سجلات DNS لدى مسجّل النطاق.",
  domainRemoveBody: "لن يتمكن زوار هذا النطاق من الوصول إلى متجرك بعد الآن. تذكّر حذف سجلات DNS لدى مسجّل النطاق.",
  domainDnsIntro: "أضف هذه السجلات لدى مسجّل النطاق أو مزوّد DNS. قد يستغرق انتشار التغييرات من بضع دقائق حتى 48 ساعة.",
  domainVerifyOwnership: "التحقق من الملكية",
  domainPointToStore: "توجيه النطاق إلى متجرك",
  domainRootNote: "لا تسمح معظم الجهات المزوّدة باستخدام CNAME على النطاقات الجذرية. استخدم ALIAS/ANAME (أو قيمة سجل A المعروضة)، أو اربط بدلًا من ذلك نطاقًا فرعيًا مثل www أو shop.",
  domainRedirecting: "تتم إعادة توجيه زوار هذا النطاق إلى نطاقك الأساسي.",
  domainServing: "يعرض هذا النطاق المتجر مباشرة (دون إعادة توجيه).",
  domainStopRedirect: "إيقاف إعادة التوجيه",
  domainRedirectToPrimary: "إعادة التوجيه إلى الأساسي",
  domainDnsType: "النوع",
  domainDnsName: "الاسم / المضيف",
  domainDnsValue: "القيمة",
  domainUnknown: "نطاق غير معروف",
  domainAdded: "تمت إضافة {host}. أنشئ سجلات DNS أدناه، ثم اختر «افحص الآن».",
  domainVerifiedHttps: "تم التحقق، وHTTPS نشط.",
  domainVerifiedPendingSsl: "تم التحقق. لا تزال شهادة HTTPS قيد الإصدار.",
  domainCheckedFailed: "تم الفحص للتو، وفشل التحقق.",
  domainCheckedPending: "تم الفحص للتو، ولا يزال قيد الانتظار.",
  domainPrimaryUpdated: "تم تحديث النطاق الأساسي",
  domainPlatformPrimary: "أصبح العنوان على المنصة هو الأساسي الآن",
  domainRemoved: "تمت إزالة النطاق",

  // Payments
  payDescription: "اربط حسابات الدفع الخاصة بك. تذهب أموال عملائك مباشرة إلى الحسابات التي تربطها هنا.",
  payStripeConnectedTitle: "تم ربط حساب Stripe",
  payStripeConnectedBody: "أجرِ اختبار اتصال، ثم فعّل Stripe عند الدفع.",
  payStripeErrorTitle: "لم يكتمل الربط مع Stripe",
  payStripeErrorBody: "تعذّر إكمال محاولة الربط. يرجى المحاولة مرة أخرى.",
  payCustomersSee: "ما يراه العملاء حاليًا عند الدفع:",
  payTestModeWarning: "لا يمكن لطريقة دفع في وضع الاختبار استلام مدفوعات حقيقية. انتقل إلى بيانات اعتماد الإنتاج قبل الإطلاق.",
  payNoneEnabledTitle: "لا يمكن للعملاء إتمام الدفع حتى تفعّل طريقة دفع.",
  payNoneEnabledBody: "اربط مزوّد دفع إلكتروني أو أعدّ الدفع عند الاستلام / التحويل البنكي، ثم اختر «تفعيل عند الدفع».",
  payOwnAccountsNote: "يستخدم كل متجر فقط حسابات الدفع المرتبطة في هذه الصفحة. لا تعالج Storelancer طلبات متجرك أبدًا عبر حساب تابع للمنصة، ولا يوجد حساب احتياطي؛ فإذا لم يتم تفعيل أي طريقة، يكون الدفع غير متاح. يفرض مزوّد الدفع رسوم المعالجة.",
  payProblemTitle: "مشكلة في اتصال الدفع",
  payProblemBody: "تحتاج المزوّدات التالية إلى انتباهك: {providers}. تُزال طرق الدفع التي تفشل في اختبار الاتصال من صفحة الدفع تلقائيًا.",
  payProblemBody_one: "يحتاج {providers} إلى انتباهك. تُزال طرق الدفع التي تفشل في اختبار الاتصال من صفحة الدفع تلقائيًا.",
  payProviders: "مزوّدو الدفع",
  payComingLater: "قريبًا",
  payComingLaterDesc: "هذه المزوّدات غير مدعومة بعد ولا يمكن ربطها. وهي مدرجة لتعرف ما هو مخطط له.",
  payCheckoutSettingsNote: "هل تحتاج إلى تحديد العملاء الذين يمكنهم الدفع كضيوف أو مدة حجز المخزون أثناء الدفع الإلكتروني؟ راجع {link}.",
  payCheckoutSettingsLink: "إعدادات الدفع",
  payState_not_connected: "غير مرتبط",
  payState_setup_required: "يتطلب الإعداد",
  payState_connected: "مرتبط · غير مفعّل",
  payState_test_mode: "نشط عند الدفع · وضع الاختبار",
  payState_active: "نشط عند الدفع",
  payState_connection_problem: "مشكلة في الاتصال",
  payState_reauth_required: "يتطلب إعادة التفويض",
  payState_unavailable: "غير متاح مؤقتًا",
  payState_not_supported: "غير مدعوم بعد",
  providerName_cod: "الدفع عند الاستلام",
  providerName_bank_transfer: "تحويل بنكي",
  providerDesc_stripe: "البطاقات والمحافظ الإلكترونية وطرق الدفع المحلية عبر صفحة دفع Stripe. تُسوّى المدفوعات في حساب Stripe الخاص بك.",
  providerDesc_paypal: "الدفع عبر محفظة PayPal باستخدام بيانات اعتماد تطبيق REST الخاص بحساب PayPal التجاري لديك.",
  providerDesc_cod: "يدفع العميل لمندوب التوصيل أو لك شخصيًا. تؤكد الدفع يدويًا.",
  providerDesc_bank_transfer: "اعرض بياناتك البنكية بعد إتمام الطلب. تحدد الطلب كمدفوع عند وصول الأموال.",
  providerDescNotSupported: "غير مدعوم بعد. واجهة المحوّل جاهزة لهذا التكامل، لكنه غير مُنفَّذ، لذا لا يمكن ربطه.",
  providerRegions_stripe: "متاح في أكثر من 45 دولة. راجع قائمة Stripe لبلد نشاطك التجاري.",
  providerRegions_paypal: "متاح في أكثر من 200 سوق، ويختلف دعم العملات.",
  providerRegions_cod: "في أي مكان يمكنك فيه تحصيل المبلغ عند التسليم.",
  providerRegions_bank_transfer: "في أي مكان.",
  providerMethods_stripe: "البطاقات، Apple Pay، Google Pay، وطرق الدفع المحلية المفعّلة في لوحة تحكم Stripe",
  providerMethods_paypal: "محفظة PayPal، والدفع لاحقًا / البطاقات حيث يوفرها PayPal",
  providerMethods_cod: "نقدًا أو بالبطاقة عند الاستلام",
  providerMethods_bank_transfer: "تحويل بنكي يدوي",
  payModeLive: "إنتاج",
  payModeTest: "اختبار",
  payDocs: "التوثيق ↗",
  payDocsSr: " الخاص بـ{name} (يفتح في علامة تبويب جديدة)",
  payMethods: "طرق الدفع",
  payRegions: "المناطق",
  payAccount: "الحساب",
  payViaConnect: " · عبر Stripe Connect",
  payViaKeys: " · عبر مفاتيح API",
  payLastVerified: "آخر تحقق",
  payCredentials: "بيانات الاعتماد",
  payCredentialsSaved: "تم حفظ بيانات الاعتماد (مشفّرة، ولن تُعرض مرة أخرى)",
  payUnavailableTitle: "{name} غير متاح مؤقتًا على هذه المنصة",
  payUnavailableDefault: "أوقفت المنصة مؤقتًا الاتصالات الجديدة والدفع لهذا المزوّد.",
  paySettingsKept: "يتم الاحتفاظ بالإعدادات الحالية.",
  payLastErrorTitle: "آخر خطأ من المزوّد",
  payReauth: "لم يعد المزوّد يقبل هذا التفويض. أعد ربط الحساب أدناه.",
  payMissingConfig: "إعدادات ناقصة",
  payStripeKeysIntro: "في لوحة تحكم Stripe افتح {path} وأنشئ {restricted} (موصى به) أو انسخ مفتاحك السري. يتم التحقق من المفاتيح مع Stripe ثم تشفيرها، ولن تُعرض مرة أخرى أبدًا.",
  payStripeKeysPath: "Developers → API keys",
  payStripeRestrictedKey: "مفتاحًا مقيّدًا",
  payStripeSecretKey: "المفتاح السري أو المقيّد",
  payStripeSecretKeyHint: "يبدأ بـ sk_test_ أو sk_live_ أو rk_test_ أو rk_live_. مفاتيح الاختبار تُنشئ مدفوعات في وضع الاختبار فقط.",
  payWebhookSigningSecret: "سرّ توقيع Webhook",
  payWebhookSigningSecretHint: "يبدأ بـ whsec_. يمكنك إضافته بعد إنشاء نقطة نهاية Webhook أدناه.",
  payVerifyingStripe: "جارٍ التحقق مع Stripe…",
  payReplaceApiKey: "استبدال مفتاح API",
  payVerifySaveKey: "تحقق واحفظ المفتاح",
  payReconnectStripe: "إعادة الربط مع Stripe",
  payConnectStripe: "الربط مع Stripe",
  payStripeOauthNote: "ستسجّل الدخول إلى Stripe وتفوّض هذا المتجر. تُسوّى المدفوعات مباشرة في حساب Stripe الخاص بك.",
  payStripeOauthUnavailable: "خدمة Stripe Connect بنقرة واحدة غير مُعدّة على هذه المنصة. اربط حساب Stripe الخاص بك باستخدام مفتاح API بدلًا من ذلك.",
  payUseApiKeys: "استخدام مفاتيح API بدلًا من ذلك",
  payStripeConnectNote: "مرتبط عبر Stripe Connect. تُرسل أحداث الدفع إلى Webhook ‏Connect الخاص بالمنصة وتُوجَّه إلى هذا المتجر تلقائيًا.",
  payPaypalIntro: "أنشئ تطبيق REST على {path} باستخدام حساب PayPal {business} الخاص بك، ثم الصق بيانات اعتماده. يتم التحقق منها مع PayPal وتخزينها مشفّرة.",
  payPaypalPath: "developer.paypal.com → Apps & Credentials",
  payPaypalBusiness: "التجاري",
  payClientId: "معرّف العميل (Client ID)",
  payClientSecret: "سرّ العميل (Client secret)",
  payEnvironment: "البيئة",
  payEnvironmentHint: "بيئة Sandbox مخصصة للاختبار، ولا تنتقل فيها أموال حقيقية.",
  paySandbox: "Sandbox (اختبار)",
  payLive: "إنتاج",
  payWebhookId: "معرّف Webhook",
  payWebhookIdHint: "من Webhook الذي تنشئه في تطبيق PayPal الخاص بك.",
  payVerifyingPaypal: "جارٍ التحقق مع PayPal…",
  payReplaceCredentials: "استبدال بيانات الاعتماد",
  payVerifySave: "تحقق واحفظ",
  payWebhook: "Webhook",
  paySigningSecretSaved: "تم حفظ سرّ التوقيع",
  payWebhookIdSaved: "تم حفظ معرّف Webhook",
  payNotConfigured: "غير مُعدّ",
  payStripeWebhookIntro: "في Stripe افتح {path}، والصق هذا الرابط واختر الأحداث أدناه. ثم انسخ سرّ توقيع نقطة النهاية هنا.",
  payStripeWebhookPath: "Developers → Webhooks → Add endpoint",
  payPaypalWebhookIntro: "في تطبيق PayPal الخاص بك، أضف Webhook بهذا الرابط والأحداث أدناه. ثم الصق معرّف Webhook هنا.",
  payCopyUrl: "نسخ الرابط",
  payEventsToEnable: "الأحداث المطلوب تفعيلها",
  payReplaceSigningSecret: "استبدال سرّ التوقيع",
  paySigningSecret: "سرّ التوقيع",
  payReplaceWebhookId: "استبدال معرّف Webhook",
  payWebhookIdPlaceholder: "مثل 8PT597110X687430LKGECATA",
  payNameAtCheckout: "الاسم المعروض عند الدفع",
  payDefaultsTo: "الافتراضي: «{name}».",
  payBankDetails: "البيانات البنكية والتعليمات",
  payBankDetailsHint: "تظهر للعملاء بعد تقديم الطلب وفي رسالة التأكيد. أدرج اسم صاحب الحساب ورقم IBAN/الحساب واسم البنك والمرجع الذي يجب استخدامه (مثل رقم الطلب).",
  paySetUp: "إعداد {name}",
  payEditSettings: "تعديل الإعدادات",
  payDisabling: "جارٍ الإيقاف…",
  payDisable: "إيقاف عند الدفع",
  payEnabling: "جارٍ التفعيل…",
  payEnable: "تفعيل عند الدفع",
  payTesting: "جارٍ الاختبار…",
  payTestConnection: "اختبار الاتصال",
  payDisconnectTitle: "فصل {name}؟",
  payDisconnect: "فصل",
  payDisconnectBody: "لن يرى العملاء {name} عند الدفع بعد الآن.",
  payDisconnectBodyCredentials: "لن يرى العملاء {name} عند الدفع بعد الآن، وسيتم حذف بيانات الاعتماد المحفوظة.",
  payDisconnectInProgress: "إذا كانت لدى العملاء عمليات دفع جارية مع هذا المزوّد، فسيُمنع الفصل حتى تكتمل أو تنتهي صلاحيتها.",
  payDisconnectRefunds: "تتطلب استردادات الطلبات السابقة المدفوعة عبر {name} إعادة ربط الحساب نفسه، أو يمكن إصدارها من لوحة تحكم المزوّد مباشرة.",
  payEnabledNote: "يمكن للعملاء اختيار هذه الطريقة عند الدفع (وفقًا للقواعد أدناه).",
  payDisabledNote: "لا تظهر للعملاء حتى تفعّلها.",
  payRulesSummary: "قواعد الدفع (العملات، الدول، قيمة الطلب)",
  payRulesIntro: "حدّد متى تُعرض هذه الطريقة. اترك القاعدة فارغة للسماح بكل شيء.",
  payCurrencies: "العملات",
  payAllCurrencies: "جميع العملات",
  payStoreSellsIn: "يبيع متجرك بعملة {currency}.",
  payCustomerCountries: "دول العملاء",
  payAllCountries: "جميع الدول",
  payCountriesHint: "بناءً على بلد الشحن/الفوترة للعميل.",
  payMinAmount: "الحد الأدنى لقيمة الطلب",
  payMaxAmount: "الحد الأقصى لقيمة الطلب",
  paySaveRules: "حفظ القواعد",
  payUnknownConnection: "اتصال دفع غير معروف",
  payUnknownMethod: "طريقة غير معروفة",
  payStripeSaved: "تم التحقق من بيانات اعتماد Stripe وحفظها (وضع الإنتاج). الخطوة التالية: أضف Webhook أدناه، وأجرِ اختبار اتصال، ثم فعّل Stripe عند الدفع.",
  payStripeSavedTest: "تم التحقق من بيانات اعتماد Stripe وحفظها (وضع الاختبار). الخطوة التالية: أضف Webhook أدناه، وأجرِ اختبار اتصال، ثم فعّل Stripe عند الدفع.",
  payPaypalSaved: "تم التحقق من بيانات اعتماد PayPal وحفظها (إنتاج). فعّل PayPal عند الدفع عندما تكون جاهزًا.",
  payPaypalSavedSandbox: "تم التحقق من بيانات اعتماد PayPal وحفظها (Sandbox). فعّل PayPal عند الدفع عندما تكون جاهزًا.",
  payOfflineSaved: "تم حفظ {name}. فعّله عبر «تفعيل عند الدفع».",
  payOfflineEnabled: "أصبح {name} متاحًا الآن عند الدفع.",
  payTestFailed: "فشل اختبار الاتصال: {reason}. تمت إزالة هذه الطريقة من صفحة الدفع حتى ينجح الاختبار.",
  payTestFailedDefault: "رفض المزوّد الطلب",
  payTestOkLive: "الاتصال سليم{account} (وضع الإنتاج).",
  payTestOkTest: "الاتصال سليم{account} (وضع الاختبار).",
  payEnabledInCheckout: "تم التفعيل عند الدفع",
  payRemovedFromCheckout: "تمت الإزالة من صفحة الدفع",
  payMaxBelowMin: "يجب ألا يقل الحد الأقصى لقيمة الطلب عن الحد الأدنى.",
  payMaxBelowMinField: "يجب ألا يقل عن الحد الأدنى",
  payRulesSaved: "تم حفظ قواعد الدفع",
  payDisconnected: "تم الفصل. وحُذفت بيانات الاعتماد المخزنة.",
  payPasteValue: "الصق القيمة من لوحة تحكم المزوّد.",
  payWebhookSaved: "تم حفظ إعداد Webhook",

  // Team
  teamDescription: "الأشخاص الذين يمكنهم المساعدة في إدارة هذا المتجر، وما يمكن لكل منهم فعله.",
  teamInvite: "دعوة شخص",
  teamSeats: "حسابات الموظفين المستخدمة: {used} من {count} ضمن خطة {plan} (لا يُحتسب المالك).",
  teamSeats_one: "حسابات الموظفين المستخدمة: {used} من {count} ضمن خطة {plan} (لا يُحتسب المالك).",
  teamNotIncluded: "حسابات الفريق غير مشمولة في خطة {plan}",
  teamUpgrade: "قم بالترقية لدعوة موظفين.",
  teamOnlyOwnerAdmins: "يمكن لمالك المتجر فقط دعوة المسؤولين.",
  teamMembers: "الأعضاء",
  teamMemberCount: "عدد الأعضاء: {count}",
  teamMemberCount_one: "عضو واحد",
  teamYou: "(أنت)",
  teamRoleFor: "دور {email}",
  teamRemoveTitle: "إزالة {name}؟",
  teamRemoveBody: "سيفقد هذا الشخص الوصول إلى المتجر فورًا. تبقى إجراءاته السابقة في سجل النشاط.",
  teamPendingInvites: "الدعوات المعلّقة",
  teamExpires: "{role} · تنتهي في {date}",
  teamRevokeTitle: "إلغاء دعوة {email}؟",
  teamRevoke: "إلغاء",
  teamRolesTitle: "الأدوار والصلاحيات",
  teamRolesDesc: "تقتصر المدفوعات والاستردادات والوصول إلى الفريق على الأدوار أدناه. يفرض الخادم هذه القيود على كل إجراء.",
  teamRoleDesc_owner: "وصول كامل، بما في ذلك الفوترة والمدفوعات والنشر. لا يمكن إزالته.",
  teamRoleDesc_admin: "كل شيء باستثناء الفوترة: المنتجات، الطلبات والاستردادات، المدفوعات، النطاقات، الفريق والنشر.",
  teamRoleDesc_product_manager: "المنتجات والمجموعات والمخزون ومحرر المتجر والصفحات. يمكنه عرض التحليلات.",
  teamRoleDesc_order_manager: "الطلبات (بما في ذلك الاستردادات والتنفيذ) والمخزون وإعدادات الشحن. يمكنه عرض العملاء.",
  teamRoleDesc_support: "عرض الطلبات وإدارة العملاء. بدون استردادات أو إعدادات.",
  teamRoleDesc_analyst: "وصول للقراءة فقط إلى الطلبات والعملاء والتحليلات.",
  teamUnknownMember: "عضو فريق غير معروف",
  teamInviteEmailed: "تم إرسال الدعوة بالبريد الإلكتروني إلى {email}.",
  teamInviteCreated: "تم إنشاء دعوة لـ {email}.",
  teamInviteRevoked: "تم إلغاء الدعوة",
  teamRoleUpdated: "تم تحديث الدور",
  teamMemberRemoved: "تمت إزالة العضو",
};

export default ar;
